import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const RecentPostCard = ({ post, onLike, onReply, onFollow }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6 hover:shadow-wellness transition-wellness">
      <div className="flex items-start space-x-4">
        <Image
          src={post?.author?.avatar}
          alt={post?.author?.name}
          className="w-12 h-12 rounded-full object-cover"
        />
        
        <div className="flex-1 min-w-0">
          <div className="flex items-center space-x-2 mb-2">
            <h3 className="font-heading font-semibold text-foreground">
              {post?.author?.name}
            </h3>
            
            {post?.author?.badges?.map((badge, index) => (
              <div key={index} className={`px-2 py-1 rounded-full text-xs font-caption ${badge?.color}`}>
                {badge?.name}
              </div>
            ))}
            
            <span className="text-muted-foreground text-sm">•</span>
            <span className="text-muted-foreground text-sm">{post?.timeAgo}</span>
          </div>
          
          <div className="mb-3">
            <div className="flex items-center space-x-2 mb-2">
              <span className="bg-primary/10 text-primary px-2 py-1 rounded-full text-xs font-medium">
                {post?.category}
              </span>
              {post?.isPinned && (
                <Icon name="Pin" size={14} className="text-accent" />
              )}
            </div>
            
            <h4 className="font-medium text-foreground text-lg mb-2">
              {post?.title}
            </h4>
            
            <p className="text-muted-foreground text-sm line-clamp-3">
              {post?.content}
            </p>
          </div>
          
          {post?.image && (
            <div className="mb-4 rounded-lg overflow-hidden">
              <Image
                src={post?.image}
                alt="Post image"
                className="w-full h-48 object-cover"
              />
            </div>
          )}
          
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onLike(post?.id)}
                className={`${post?.isLiked ? 'text-error' : 'text-muted-foreground'}`}
              >
                <Icon name={post?.isLiked ? "Heart" : "Heart"} size={16} />
                <span className="ml-1">{post?.likes}</span>
              </Button>
              
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onReply(post?.id)}
                className="text-muted-foreground"
              >
                <Icon name="MessageCircle" size={16} />
                <span className="ml-1">{post?.replies}</span>
              </Button>
              
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onFollow(post?.id)}
                className="text-muted-foreground"
              >
                <Icon name="Bookmark" size={16} />
                <span className="ml-1">Save</span>
              </Button>
            </div>
            
            <div className="flex items-center space-x-2">
              {post?.lastReply && (
                <div className="flex items-center space-x-2 text-xs text-muted-foreground">
                  <span>Last reply by</span>
                  <Image
                    src={post?.lastReply?.avatar}
                    alt={post?.lastReply?.name}
                    className="w-6 h-6 rounded-full object-cover"
                  />
                  <span>{post?.lastReply?.name}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecentPostCard;